'use strict';

angular.module('docketbook').
  controller('editUserModal', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, userService) {

    $scope.member = {}
    $scope.groupsMemberships = []
    $scope.removedMemberships = []
    $scope.groupDict = {}
    $scope.allRoles = []
    $scope.roleDict = {}
    $scope.monitorGroups = []
    $scope.adminGroups = []
    $scope.saving = false
    $scope.superUser = false
    $scope.originalMemberships = []
    $scope.rootGroup = {}
    $scope.originalMemberships = []
    $scope.originalAdminGroups = []


    $scope.$parent.showEditUserModal = function (member) {
      $scope.saving = false
      $scope.member = member
      $scope.groupsMemberships = []
      $scope.removedMemberships = []
      $scope.monitorGroups = []
      $scope.rootGroup = $scope.currentOrg.groups.filter(x => x.parent == null)[0]

      $scope.superUser = $scope.member.isGlobalAdmin

      $scope.allRoles = []
      $scope.roleDict = {}

      $scope.groupDict = {}

      $scope.currentOrg.groups.forEach(group => {
        $scope.groupDict[group.id] = group

        if (group.monitors/*.map(m => m.id)*/.includes($scope.member.id)) {
          $scope.monitorGroups.push(group.id)
        }
        if (group.owners/*.map(o => o.id)*/.includes($scope.member.id)) {
          $scope.adminGroups.push(group.id)
        }

        const roles =
          group.members
            .filter(m => m.user == $scope.member.id)
            .map(m => m.role)


        if (roles.length > 0) {
          $scope.groupsMemberships.push({
            groups: [group.id],
            roles: roles,
          })
        }
      })

      $scope.groupsMemberships = _.sortBy($scope.groupsMemberships, membership => $scope.groupDict[membership.groups[0]].parents.length == 0 ? -99 : $scope.groupDict[membership.groups[0]].name)
      $scope.originalMemberships = $scope.groupsMemberships.slice()
      $scope.originalMonitorGroups = $scope.monitorGroups.slice()
      $scope.originalAdminGroups = $scope.adminGroups.slice()

      $scope.groupsMemberships.forEach(membership => {
        membership.original = Object.assign({}, membership)
      })

      userService.getRoles(null, function (roles) {
        $scope.allRoles = roles
        roles.forEach(role => $scope.roleDict[role.id] = role)
      }, function (err) {
        $scope.allRoles = []
      })

      $("#editUserModal").fadeIn(100)
    }

    $scope.roleSelect = function (membership, role) {
      if (membership.original != null
        && membership.groups[0] == $scope.rootGroup.id
        && membership.roles.length == 1
        && membership.roles[0] == role.id
      ) {
        swal({
          title: "Cannot remove all roles from Main Group",
          text: "Main Group must have at least one role remaining.",
          type: "warning",
          confirmButtonText: "Ok"
        })
      }
    }

    $scope.getGroupsText = function (membership) {
      if (membership.groups && membership.groups.length > 0) {
        return membership.groups.map(group => {
          if ($scope.groupDict[group] == null) {
            return 'Unknown'
          }
          else if ($scope.groupDict[group].parents.length == 0) {
            return 'Main Group'
          } else {
            return $scope.groupDict[group].name
          }
        }).join(',<br></br>')
      } else {
        return 'Select Groups'
      }
    }

    $scope.getRolesText = function (membership) {
      if (membership.roles && membership.roles.length > 0) {
        return membership.roles.map(role => $scope.roleDict[role] ? $scope.roleDict[role].name : 'Unknown').join(',<br></br>')
      } else {
        return 'Select Roles'
      }
    }

    $scope.monitorsAny = function (membership) {
      if (membership.groups == null) {
        return false;
      }
      return membership.groups.map(group => $scope.monitorGroups.includes(group)).includes(true)
    }

    $scope.monitorsAll = function (membership) {
      if (membership.groups == null || membership.groups.length == 0) {
        return false;
      }
      return !membership.groups.map(group => $scope.monitorGroups.includes(group)).includes(false)
    }

    $scope.toggleMonitor = function (membership) {
      const remove = $scope.monitorsAll(membership)

      membership.groups.forEach(group => {
        if (remove) {
          $scope.monitorGroups = _.without($scope.monitorGroups, group)
        } else {
          if (!$scope.monitorGroups.includes(group)) {
            $scope.monitorGroups.push(group)
          }
        }
      })
    }

    $scope.adminsAny = function (membership) {
      if (membership.groups == null) {
        return false;
      }
      return membership.groups.map(group => $scope.adminGroups.includes(group)).includes(true)
    }

    $scope.adminsAll = function (membership) {
      if (membership.groups == null || membership.groups.length == 0) {
        return false;
      }
      return !membership.groups.map(group => $scope.adminGroups.includes(group)).includes(false)
    }

    $scope.toggleAdmin = function (membership) {
      const remove = $scope.adminsAll(membership)

      membership.groups.forEach(group => {
        if (remove) {
          $scope.adminGroups = _.without($scope.adminGroups, group)
        } else {
          if (!$scope.adminGroups.includes(group)) {
            $scope.adminGroups.push(group)
          }
        }
      })
    }

    $scope.cancel = function () {
      $("#editUserModal").fadeOut(100)
    }

    var finished = function () {
      $scope.saving = false
      userService.getOrganisation($scope.currentOrg.id, gotGroup => $scope.currentOrg = gotGroup)
      $scope.$parent.getMembers().then(function () {
        $scope.$parent.loadAllUsers()
      })

      //$("#editUserModal").fadeOut(100)
      window.location.reload()
    }

    $scope.removeUser = function () {
      swal({
        title: "Remove User",
        text: `Are you sure you wish to remove ${$scope.member.name.full} entirely from the company?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          var groupsToRemove = _.sortBy($scope.originalMemberships.map(m => m.groups[0]), group => $scope.groupDict[group].parent == null ? 0 : 1)
          var removedAdmins = $scope.originalAdminGroups.slice()
          var removedMonitors = $scope.originalMonitorGroups.slice()
          const failures = []

          const removeSuperuser = () => {
            if ($scope.superUser) {
              var globalAdministrators = $scope.currentOrg.globalAdministrators.slice()
              globalAdministrators = _.without(globalAdministrators, $scope.member.id)
              userService.updateOrganisation(
                $scope.currentOrg.id, { globalAdministrators },
                finished,
                err => {
                  failures.push(err)
                  finished()
                })
            } else {
              finished()
            }
          }

          const removeOneGroup = () => {
            if (groupsToRemove.length == 0) {
              removeSuperuser()
              return;
            }
            const toRemove = groupsToRemove.pop()
            userService.removeMemberFromGroup(toRemove, $scope.member.id, removeOneGroup, function (err) {
              $scope.alertService.presentAutoAlert('removeGroupMember', err);
              removeOneGroup()
            });
          }

          const removeOneAdmin = () => {
            if (removedAdmins.length <= 0) {
              removeOneGroup()
              return
            }

            const toRemove = removedAdmins.pop()
            userService.removeOwnerFromGroup(toRemove, $scope.member.id, removeOneAdmin, err => {
              failures.push(err)
              removeOneAdmin()
            })
          }

          const removeOneMonitor = () => {
            if (removedMonitors.length <= 0) {
              removeOneAdmin()
              return
            }

            const toRemove = removedMonitors.pop()
            userService.removeMonitorFromGroup(toRemove, $scope.member.id, removeOneMonitor, err => {
              failures.push(err)
              removeOneMonitor()
            })
          }
          removeOneMonitor()
        }
      });
    }

    $scope.allGroupsClick = function (membership) {
      if (membership.groups == null || !membership.groups.includes('All Groups')) {
        // 'All Groups' is added after this function
        membership.groups = [...$scope.currentOrg.groups.map(group => group.id)]
      } else {
        membership.groups = ['All Groups']
      }
    }

    $scope.saveUser = function () {
      const validMemberships = $scope.groupsMemberships.map(membership => {
        var dupe = Object.assign({}, membership)
        if (dupe.groups == null) { dupe.groups = [] }
        if (dupe.roles == null) { dupe.roles = [] }
        dupe.groups = _.without(dupe.groups, 'All Groups')

        return dupe
      })

      var edits = validMemberships.filter(g => g.original != null)
      var newMemberships = validMemberships.filter(g => g.original == null)
      var removedMemberships = $scope.removedMemberships.slice()

      edits.forEach(membership => {
        const og = membership.original

        const newGroups = _.without(membership.groups, ...og.groups)
        const removedGroups = _.without(og.groups, ...membership.groups)
        const newRoles = _.without(membership.roles, ...og.roles)
        const removedRoles = _.without(og.roles, ...membership.roles)

        if (newGroups.length > 0) {
          newMemberships.push({ groups: newGroups, roles: membership.roles })
        }
        if (newRoles.length > 0) {
          newMemberships.push({ groups: membership.groups, roles: newRoles })
        }
        if (removedGroups.length > 0) {
          removedMemberships.push({ groups: removedGroups, roles: og.roles })
        }
        if (removedRoles.length > 0) {
          removedMemberships.push({ groups: og.groups, roles: removedRoles })
        }
      })

      var individualAdds =
        _.uniq(_.flatten(_.flatten(
          newMemberships.map(membership =>
            membership.groups.map(group =>
              membership.roles.map(role => ({ group, role }))
            )
          )
        )))

      var individualDeletes =
        _.uniq(_.flatten(_.flatten(
          removedMemberships.map(membership =>
            membership.groups.map(group =>
              membership.roles.map(role => ({ group, role }))
            )
          )
        )))

      // ignore where roles have been both added and removed
      const overlaps = individualAdds.filter(x => _.findIndex(individualDeletes, x) != -1)
      individualAdds = individualAdds.filter(x => _.findIndex(overlaps, x) == -1)
      individualDeletes = individualDeletes.filter(x => _.findIndex(overlaps, x) == -1)


      const groupsWithRoles = _.uniq(_.flatten($scope.groupsMemberships.filter(x => x.roles != null && x.roles.length > 0).map(x => x.groups)))
      const monitorGroupsWithRoles = $scope.monitorGroups.filter(group => groupsWithRoles.includes(group))

      // Monitor edits
      var addedMonitors = _.without(monitorGroupsWithRoles, ...$scope.originalMonitorGroups, 'All Groups')
      var removedMonitors = _.without($scope.originalMonitorGroups, ...monitorGroupsWithRoles, 'All Groups')

      // Admin edits
      var addedAdmins = _.without($scope.adminGroups, ...$scope.originalAdminGroups)
      var removedAdmins = _.without($scope.originalAdminGroups, ...$scope.adminGroups)

      $scope.saving = true

      const addSuperUser = $q((pass, fail) => {
        if ($scope.member.isGlobalAdmin != $scope.superUser) {
          var globalAdministrators = $scope.currentOrg.globalAdministrators.slice()

          if ($scope.superUser) {
            globalAdministrators.push($scope.member.id)
          } else {
            globalAdministrators = _.without(globalAdministrators, $scope.member.id)
          }

          userService.updateOrganisation($scope.currentOrg.id, { globalAdministrators }, pass, fail)
        } else {
          pass()
        }
      })

      addSuperUser.then(() => {
        var failures = [];

        const removeOneAdmin = () => {
          if (removedAdmins.length <= 0) {
            addOneMembership()
            return
          }

          const toRemove = removedAdmins.pop()
          userService.removeOwnerFromGroup(toRemove, $scope.member.id, removeOneAdmin, err => {
            failures.push(err)
            removeOneAdmin()
          })
        }

        const addOneAdmin = () => {
          if (addedAdmins.length <= 0) {
            removeOneAdmin()
            return
          }

          const toAdd = addedAdmins.pop()
          const person = [{ user: $scope.member.id, roles: ['owner'] }]
          userService.assignMembersToGroup(toAdd, person, addOneAdmin, err => {
            failures.push(err)
            addOneAdmin()
          })
        }

        const removeOneMonitor = () => {
          if (removedMonitors.length <= 0) {
            addOneAdmin()
            return;
          }

          const toRemove = removedMonitors.pop()
          userService.removeMonitorFromGroup(toRemove, $scope.member.id, removeOneMonitor, err => {
            failures.push(err)
            removeOneMonitor()
          })
        }

        const addOneMonitor = () => {
          if (addedMonitors.length <= 0) {
            removeOneMonitor()
            return
          }

          const toAdd = addedMonitors.pop()
          var person = [{ user: $scope.member.id, roles: ['monitor'] }]

          userService.assignMembersToGroup(toAdd, person, addOneMonitor, err => {
            failures.push(err)
            addOneMonitor()
          })
        }

        const removeOneMembership = () => {
          if (individualDeletes.length <= 0) {
            finished()
            return
          }

          const toRemove = individualDeletes.pop()
          userService.removeMemberRoleFromGroup(toRemove.group, $scope.member.id, toRemove.role, removeOneMembership, err => {
            failures.push(err)
            removeOneMembership()
          })
        }

        const addOneMembership = () => {
          if (individualAdds.length <= 0) {
            return removeOneMembership()
          }

          const toAdd = individualAdds.pop()
          const memberAdd = { user: $scope.member.id, role: toAdd.role }
          userService.addMemberToGroup(toAdd.group, memberAdd, addOneMembership, err => {
            failures.push(err)
            addOneMembership()
          })
        }
        addOneMonitor()
      })
    }

    $scope.toggleSuperUser = function () {
      $scope.superUser = !$scope.superUser
    }

    $scope.removeMembership = function (membership) {
      $scope.groupsMemberships = _.without($scope.groupsMemberships, membership);
      // only add removals if it's not a new row
      if (!membership.edit || membership.original) {
        $scope.removedMemberships.push(membership)
      }

      // Remove the monitor flag for any group in the membership that was a monitor and is no longer listed in the modal
      membership.groups
        .filter(group => $scope.monitorGroups.includes(group))
        .forEach(removedGroup => {
          const otherGroups = _.flatten($scope.groupsMemberships.map(membership => membership.groups))
          if (!otherGroups.includes(removedGroup)) {
            $scope.monitorGroups = _.without($scope.monitorGroups, removedGroup)
          }
        })

      membership.groups
        .filter(group => $scope.adminGroups.includes(group))
        .forEach(removedGroup => {
          const otherGroups = _.flatten($scope.groupsMemberships.map(membership => membership.groups))
          if (!otherGroups.includes(removedGroup)) {
            $scope.adminGroups = _.without($scope.adminGroups, removedGroup)
          }
        })
    }

    $scope.addMembership = function () {
      $scope.groupsMemberships.push({ groups: [], role: {}, new: true })
    }

  })



// WEBPACK FOOTER //
// ./src/controllers/modals/editUserModalController.js